exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".assignment-card{border-left-width:3px !important;border-left-color:#7fd3a3 !important;margin-bottom:.755rem}@media(min-width: 845px){.assignment-card .submission-info{margin-top:1rem}}", ""]);

// exports
